import { PageTypes } from '#shared/resolve-page';

interface PageData {
    type?: PageTypes;
}

export default async function useResolvePage(slug: string) {
    const { data } = await useGetShopwarePageByUrl(slug);

    if (!data) {
        return 'error';
    }

    const pageData = data as PageData;
    switch (pageData.type) {
        case PageTypes.Navigation:
        case PageTypes.ManufacturerDetail:
        case PageTypes.ManufacturerCategory:
        case PageTypes.Blog:
        case PageTypes.ProductDetail:
        case PageTypes.ShopTheLook:
        case PageTypes.Redirect:
            return data;
        case PageTypes.NotFound:
            return 'notFound';
        default:
            return 'error';
    }
}
